import type { AnalystExcerptRef } from "@/api/types";
import { t } from "@/i18n";
import { openInInspector } from "@/state/filters";

/** The excerpts a model's text cites as «[#n]», as «#n» buttons that open each
 * one's conversation in the Session Inspector (the Analyse-Chat's answers, the
 * Tagesbericht's narrative). Renders nothing without a citation. */
export function ExcerptRefs({ refs }: { refs: readonly AnalystExcerptRef[] }) {
  if (refs.length === 0) return null;
  return (
    <div class="toolbar analyst-refs">
      <span class="kpi-sub">{t("analyst.refs")}</span>
      {refs.map((cited) => (
        <button
          key={cited.ref}
          type="button"
          class="link-mono"
          title={t("analyst.open")}
          onClick={() => openInInspector(cited.session_id)}
        >
          #{cited.ref}
        </button>
      ))}
    </div>
  );
}
